import { Component, Input, OnInit } from '@angular/core';
import { UntypedFormGroup, UntypedFormControl } from '@angular/forms';
import { chooseOptionsConstant, ScreencontrolStateOptionsConstant } from 'src/app/constants/service.constants';
import { Subject } from 'rxjs';
import { ControlStateSource, REGCONFIG_CONTROL } from 'src/app/models/common';
import { CommonService } from 'src/app/services/common.service';
import * as $ from 'jquery';
import { DeleteBoxComponent } from 'src/app/common/delete-box/delete-box.component';
import { AdministrationSummaryService } from 'src/app/services/administration/administration-summary.service';
import * as _ from 'lodash';
import { NgbActiveModal, NgbModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'app-registration-configuration-addfield',
  templateUrl: './registration-configuration-addfield.component.html',
  styleUrls: ['./registration-configuration-addfield.component.scss']
})
export class RegistrationConfigurationAddfieldComponent {
  @Input() public Content: any;
  chooseOptions = chooseOptionsConstant;
  
  controlTypeOptions = [
    { label: "Select", value: 0, checked: true },
    { label: "Alpha numeric Text", value: 1 },
    { label: "Alphabet Text", value: 2 },
    { label: "Number", value: 3 },
    { label: "Single select dropdown", value: 4 },
    { label: "Multi-select dropdown", value: 10 },
    { label: "Date", value: 5 },
    { label: "Checkbox", value: 6 },
    { label: "Radio Buttons", value: 7 },
    { label: "Label", value: 9 },
    { label: "Upload", value: 8 },
    { label: "Text area", value: 11 },
  ];
  DateFormatOptions=[
    { label: "Select", value: 0, checked: true },
    { label: "DD-MMM-YYYY", value: "DD-MMM-YYYY" },
    { label: "MMM-YYYY", value: "MMM-YYYY" },
    { label: "YYYY", value: "YYYY" },
]
  controlStateOptions = ScreencontrolStateOptionsConstant;
  rowData:any[];  
  content: any;
  heading: string;
  operation: string;
  rowDataNew: REGCONFIG_CONTROL = new REGCONFIG_CONTROL();
  action: Subject<any> = new Subject();
  frameworkComponents;
  context;
  readonly: boolean = false;
  screenid: string = "";
  statesource: ControlStateSource[] = [{ "label": "Yes", "value": true }, { "label": "No", "value": false }];
  IsShowMaxLimitBox = false;
  IsShowMandatoryCheck = false;
  IsShowOption = false;
  IsShowDateFormat = false;
  IsShowupload = false;
  IsShowDropdown = false;
  IsShowMultiValues = false;
  IsShowSingleValue = false;
  IsNameEditale:boolean=false;
  MaxLength:number=99;
  OptionValues:any=[];
  constructor(public modalRef: NgbActiveModal,
    private commonService:CommonService,
    private modalService: NgbModal,
    private summaryService: AdministrationSummaryService) { }

  addControls = new UntypedFormGroup({
    ID: new UntypedFormControl(""),
    LABEL: new UntypedFormControl(null),
    SCREEN_ID: new UntypedFormControl(this.screenid),
    CONTROL: new UntypedFormControl(0),
    IS_MANDATORY: new UntypedFormControl(false),
    GROUP_VALUES: new UntypedFormControl(null),
    STATE: new UntypedFormControl(1),
    SERIAL_NO: new UntypedFormControl(1),
    PURPOSE: new UntypedFormControl(null),
    ISALLOWMULTIPLEFILES:new UntypedFormControl(false),
    SUBFIELDNAME: new UntypedFormControl(null),
    DATEFORMATE: new UntypedFormControl(null),
    IsActive: new UntypedFormControl(true),
    MAXCHARACTERLENGTH: new UntypedFormControl(null),
    IS_ADMIN_CONFIG: new UntypedFormControl(false),
  })


  ngOnInit() {
    this.readonly = false;
    if (this.Content.content != null) {
      this.operation =_.cloneDeep(this.Content.content.operation);
      this.screenid = this.Content.content.id;
   
     
      if (this.Content.heading== 'Edit')
      {      
        this.IsNameEditale=this.Content.content.Data.IS_NAME_EDITABLE;  
        let IsAllFieldsEditable=this.Content.content.Data.IS_EDITABLE;
     
        if(IsAllFieldsEditable==true || this.IsNameEditale==true) {
             this.addControls.enable();
        }
        else
        {
          this.addControls.disable();
        }
        if(this.IsNameEditale==true){
          this.addControls.controls["LABEL"].enable();
        }
        else{
          this.addControls.controls["LABEL"].disable();
        }
        this.addControls.patchValue(this.Content.content.Data);
        if(!this.Content.content.Data.IS_NAME_EDITABLE)
        {
          this.addControls.controls['LABEL'].disable();
        }
        
        var obj={value:this.Content.content.Data.CONTROL}
        this.changeControlType(obj,'Y');
        this.addControls.controls['CONTROL'].disable();
        this.addControls.controls['MAXCHARACTERLENGTH'].disable();
        this.addControls.controls['DATEFORMATE'].disable();
        this.OptionValues=[];
        if(this.Content.content.Data.GROUP_VALUES_LIST!="" && this.Content.content.Data.GROUP_VALUES_LIST!=null && this.Content.content.Data.GROUP_VALUES_LIST!=undefined)
        {
          this.OptionValues=_.cloneDeep(this.Content.content.Data.GROUP_VALUES_LIST);
        }
        this.addControls.controls['IsActive'].setValue(this.Content.content.Data.RECORD_STATE==1?true:false);
      }
    }
    this.Content.heading = this.Content.heading;
  }
validateControls():boolean{
  let isValid = true;
    let message = "";
    const formData = this.addControls.getRawValue();
    if (formData.LABEL == null || formData.LABEL == ""||formData.LABEL==undefined) {
      $("#LABEL").addClass("ng-touched ng-invalid validate-error");
      $("#LABEL").removeClass("ng-untouched ng-valid");
      message += "Please enter Field Name<br/>";
      isValid = false;
    }else if(formData.LABEL != null && formData.LABEL !=undefined&&formData.LABEL.trim()==""){
      $("#LABEL").addClass("ng-touched ng-invalid validate-error");
      $("#LABEL").removeClass("ng-untouched ng-valid");
      message += "Please enter Field Name<br/>";
      isValid = false;
    }
     else {
      $("#LABEL").addClass("ng-untouched ng-valid");
      $("#LABEL").removeClass("ng-touched ng-invalid validate-error");
    }
    if (formData.CONTROL == null || formData.CONTROL == "0" || formData.CONTROL == "") {
      $("#CONTROL").addClass("ng-touched ng-invalid validate-error");
      $("#CONTROL").removeClass("ng-untouched ng-valid");
      message += "Please select Field Type<br/>";
      isValid = false;
    } else {
      $("#CONTROL").addClass("ng-untouched ng-valid");
      $("#CONTROL").removeClass("ng-touched ng-invalid validate-error");
    }
    if(formData.CONTROL==1 || formData.CONTROL==2 || formData.CONTROL==3)
    {
      if (formData.MAXCHARACTERLENGTH === null || formData.MAXCHARACTERLENGTH === "") {
        $("#MAXCHARACTERLENGTH").addClass("ng-touched ng-invalid validate-error");
        $("#MAXCHARACTERLENGTH").removeClass("ng-untouched ng-valid");
        message += "Please enter Maximum characters Limit<br/>";
        isValid = false;
      } else {
        $("#MAXCHARACTERLENGTH").addClass("ng-untouched ng-valid");
        $("#MAXCHARACTERLENGTH").removeClass("ng-touched ng-invalid validate-error");
      }
    }
    if(!this.addControls.controls["IS_ADMIN_CONFIG"].value)
    {
      if(formData.CONTROL==4 || formData.CONTROL==10)
      {
        let isValidate = false;
        let givenlabels = [];
        if (this.OptionValues != null && this.OptionValues != undefined && this.OptionValues.length == 0) {
          message += "Please enter at least one Value<br/>";
          isValid = false;
        } else {

          this.OptionValues.forEach((item) => {
            if ((item.label == "" || item.label == null || item.label == undefined || !item.label.trim()) && !isValidate) {
              isValidate = true;
              message += "Please enter Value(s)<br/>";
              isValid = false;
            }
            else {
              let Label: string = item.label;
              if (givenlabels.indexOf(Label.toLowerCase()) > -1 && !isValidate) {
                isValidate = true;
                message += "Please enter unique Value(s)<br/>";
                isValid = false;
              }
              else {
                givenlabels.push(Label.toLowerCase());
              }
            }
          })
        }
        
      }
      if(formData.CONTROL==7 || formData.CONTROL==6)
      {let givenData = [];
        let isValidate=false;
        this.OptionValues.forEach((item)=>{
          if((item.label=="" ||item.label==null || item.label==undefined) && !isValidate)
          {
            isValidate=true;
            if(formData.CONTROL==6)
            {
              message += "Please enter Text(s)<br/>";
              isValid = false;
            }
            else{
              message += "Please enter Value(s)<br/>";
              isValid = false;
            }
          }
          else {
            if (givenData.indexOf(item.label.toLowerCase()) > -1 && !isValidate) {
              isValidate = true;
              if (formData.CONTROL == 6) {
                message += "Please enter unique Text(s)<br/>";
                isValid = false;
              }
              else {
                message += "Please enter unique Value(s)<br/>";
                isValid = false;
              }

            }
            else {
              givenData.push(item.label.toLowerCase());
            }
          }
        });
      }
    }
  
    if(formData.CONTROL==5)
    {
      if (formData.DATEFORMATE === null || formData.DATEFORMATE === "") {
        $("#DATEFORMATE").addClass("ng-touched ng-invalid validate-error");
        $("#DATEFORMATE").removeClass("ng-untouched ng-valid");
        message += "Please select Date format<br/>";
        isValid = false;
      } else {
        $("#DATEFORMATE").addClass("ng-untouched ng-valid");
        $("#DATEFORMATE").removeClass("ng-touched ng-invalid validate-error");
      }
    }
    if(formData.CONTROL==8)
    {
      if (formData.SUBFIELDNAME === null || formData.SUBFIELDNAME === "") {
        $("#SUBFIELDNAME").addClass("ng-touched ng-invalid validate-error");
        $("#SUBFIELDNAME").removeClass("ng-untouched ng-valid");
        message += "Please enter Name<br/>";
        isValid = false;
      } else {
        $("#SUBFIELDNAME").addClass("ng-untouched ng-valid");
        $("#SUBFIELDNAME").removeClass("ng-touched ng-invalid validate-error");
      }
    }
  
    if (!isValid)
    this.commonService.ValidationBanner(message);   
    return isValid;
}
  addcontrol(): any {
    if(this.validateControls())
    {
      this.rowDataNew.STATE = 1;
      this.rowDataNew.STATEVALUE = this.addControls.controls["IsActive"].value==true?"Active":"Inactive";
      this.rowDataNew.CONTROL = this.addControls.controls["CONTROL"].value;
      if(this.Content.heading=="Edit")
      {
        this.rowDataNew.ID = this.addControls.controls["ID"].value;
      }
      else{
        this.rowDataNew.ID=this.commonService.getUniqueId();
      }
      this.rowDataNew.IS_MANDATORY=this.addControls.controls["IS_MANDATORY"].value;
      this.rowDataNew.IS_MANDATORYStr=this.rowDataNew.IS_MANDATORY==true?"Yes":"No";
      this.rowDataNew.CONTROLTYPE = this.getcontroltype(this.addControls.controls["CONTROL"].value);
      this.rowDataNew.SERIAL_NO = 1;
      this.rowDataNew.SCREEN_ID = this.screenid;
      this.rowDataNew.ISALLOWMULTIPLEFILES = this.addControls.controls["ISALLOWMULTIPLEFILES"].value;
      this.rowDataNew.DATEFORMATE = this.addControls.controls["DATEFORMATE"].value;
  
      let groupValues=_.cloneDeep(this.OptionValues);
      if(groupValues!=null && groupValues!=undefined && groupValues.length)
      {
        this.rowDataNew.GROUP_VALUES_LIST=_.cloneDeep(groupValues);
        let str=[];
        groupValues.forEach((item)=>{
          str.push(item.label);
        });
        this.rowDataNew.GROUP_VALUES=str.join(",");
      }
      else{
        this.rowDataNew.GROUP_VALUES="";
        this.rowDataNew.GROUP_VALUES_LIST=[];
      
      }
      this.rowDataNew.IS_STATIC = false;
      this.rowDataNew.IS_DISPLAY = 1;
      this.rowDataNew.IS_EDITABLE = true;
      this.rowDataNew.LABEL = this.addControls.controls["LABEL"].value;
      this.rowDataNew.SUBFIELDNAME = this.addControls.controls["SUBFIELDNAME"].value;
      this.rowDataNew.LABEL = this.addControls.controls["LABEL"].value;
      this.rowDataNew.DATEFORMATE = this.addControls.controls["DATEFORMATE"].value;
      this.rowDataNew.IsActive = this.addControls.controls["IsActive"].value;
      this.rowDataNew.MAXCHARACTERLENGTH = this.addControls.controls["MAXCHARACTERLENGTH"].value==""?0:this.addControls.controls["MAXCHARACTERLENGTH"].value;
      this.rowDataNew.PURPOSE = this.addControls.controls["PURPOSE"].value;
        let IsValid=true;
        let message="";
      if (this.operation == "Add") {
        this.rowDataNew.ROWSTATE = "Add";
        this.rowDataNew.LABEL=this.rowDataNew.LABEL==null?null:this.rowDataNew.LABEL==undefined?undefined:this.rowDataNew.LABEL.trim();
          this.Content.rowData.forEach((element)=>{
            if(element.LABEL.trim().toLowerCase()==this.rowDataNew.LABEL.trim().toLowerCase() && IsValid){
              IsValid=false;
              message="Field '"+this.rowDataNew.LABEL+"' already exists. Please enter unique field name to save the details";
            }
          });
      }
      else {
        this.rowDataNew.ROWSTATE = "Edit";
        this.rowDataNew.LABEL=this.rowDataNew.LABEL==null?null:this.rowDataNew.LABEL==undefined?undefined:this.rowDataNew.LABEL.trim();
        this.Content.rowData.forEach((element)=>{
          if(element.LABEL.toLowerCase()==this.rowDataNew.LABEL.trim().toLowerCase() && element.ID!=this.rowDataNew.ID && IsValid){
            IsValid=false;
           message="Field '"+this.rowDataNew.LABEL+"' already exists. Please enter unique field name to save the details";
          }
        });
      }
      if(IsValid)
      {
       
        this.modalRef.close(this.rowDataNew);
      }
      else{
        this.commonService.ValidationBanner(message);      
      }
    
    }    
  }

  getcontroltype(ctype: any): string {
    ctype = parseInt(ctype);
    var controltype = "";
  
    switch (ctype) {
      case 1:
        controltype = "Alpha numeric Text";
        break;
      case 2:
        controltype = "Alphabet Text";
        break;
      case 3:
        controltype = "Number ";
        break;
      case 4:
        controltype = "Single select dropdown";
        break;
      case 5:
        controltype = "Date";
        break;
      case 6:
        controltype = "Checkbox";
        break;
      case 7:
        controltype = "Radio Buttons";
        break;
      case 8:
        controltype = "Upload";
       
        break;
      case 9:
        controltype = "Label";
        break;
      case 10:
        controltype = "Multi-select dropdown";
        break;
      default:

        break;
    }


    return controltype;
  }

  changeControlType(event: any,isSkip='') {
   this.OptionValues=[];
    this.IsShowMaxLimitBox = false;
    this.IsShowMandatoryCheck = false;
    this.IsShowOption = false;
    this.IsShowDateFormat = false;
    this.IsShowupload = false;
    this.IsShowDropdown = false;
    this.IsShowMultiValues = false;
    this.IsShowSingleValue = false;
    if(isSkip!='Y')
    {
      this.addControls.controls["MAXCHARACTERLENGTH"].setValue('');
      this.addControls.controls["SUBFIELDNAME"].setValue('');
    }
    switch (event.value) {
      case 1:
        this.IsShowMaxLimitBox = true;
        this.IsShowMandatoryCheck = true;
        this.MaxLength=99;
        break;
      case 2:
        this.IsShowMaxLimitBox = true;
        this.IsShowMandatoryCheck = true;
        this.MaxLength=99;
        break;
      case 3:
        this.IsShowMaxLimitBox = true;
        this.IsShowMandatoryCheck = true;
        this.MaxLength=4;
        break;
      case 4:
        this.IsShowOption=true;
        this.IsShowDropdown = true;
        this.IsShowMandatoryCheck = true;
        break;
      case 5:
        this.IsShowMandatoryCheck = true;
        this.IsShowDateFormat = true;

        break;
      case 6:
        this.IsShowMandatoryCheck = true;
        this.IsShowOption=true;
        this.IsShowMultiValues = true;
        this.OptionValues.push({value:this.commonService.getUniqueId(),label:""});

        break;
      case 7:
        this.IsShowMandatoryCheck = true;
        this.IsShowOption=true;
        this.IsShowMultiValues = true;
        this.OptionValues.push({value:this.commonService.getUniqueId(),label:""});
        this.OptionValues.push({value:this.commonService.getUniqueId(),label:""});
        break;
      case 8:
        this.IsShowMandatoryCheck = true;
        this.IsShowupload=true;
        this.IsShowSingleValue = true;
            break;
        case 9:
          this.IsShowSingleValue = true;
          break;
       case 10:
         this.IsShowMandatoryCheck = true;
        this.IsShowOption=true;
        this.IsShowDropdown = true;
            break;
      case 11:
        this.IsShowMaxLimitBox = true;
        this.IsShowMandatoryCheck = true;
        this.MaxLength=99;
            break;
    }
  }

  markDirty(evet)
  {
    this.addControls.markAsDirty();
  }
  AddValues()
  {
    if(!this.addControls.controls["IS_ADMIN_CONFIG"].value)
    {
      this.addControls.markAsDirty();
      if(this.OptionValues.length < 15){
        this.OptionValues.push({value:this.commonService.getUniqueId(),label:""});
      }
    }
  }

  RemoveValue(child) {
    this.addControls.markAsDirty();
    if (this.operation != "Add")
    {
      const modalRef = this.modalService.open(DeleteBoxComponent,{backdrop: false
        })
        modalRef.componentInstance.Content={heading: 'Delete', custommessage: 'Are you sure you want to delete ' + "'" +child.label+ "'" + ' ?',ProceedButtonName:"Delete", TerminateButtonName:"Cancel"}
        modalRef.result.then(result => {
        if(result=="okclick"){
            this.summaryService.checkRegControlValueReference(this.addControls.controls["ID"].value,child.value).subscribe((result)=>{
              if(result["Status"]==2){
                this.commonService.ValidationBanner("You cannot delete this as it is associated to an registration");
              }
              else{
                this.OptionValues.forEach((item,index)=>{
                  if(item.value==child.value){
                    this.OptionValues.splice(index,1);
                  }
                });
              }
            });
        }
      });
    }
    else{
      this.OptionValues.forEach((item,index)=>{
        if(item.value==child.value){
          this.OptionValues.splice(index,1);
        }
      });
    }
   
  }
   

  close(){
    this.canExit().then(x=>{
      this.modalRef.dismiss();
    });
  }

  moveInArray(arr, fromIndex, toIndex) {
    this.addControls.markAsDirty();
    var element = arr[fromIndex];
    arr.splice(fromIndex, 1);
    arr.splice(toIndex, 0, element);
  }

  MovePostion(naviType,element)
   {
    
    let fromIndex=this.OptionValues.indexOf(element);
     if(naviType=="down")
     {
      let toIndex=fromIndex+1;
      this.moveInArray(this.OptionValues, fromIndex, toIndex);
     }
     else{
      let toIndex=fromIndex-1;
      this.moveInArray(this.OptionValues, fromIndex, toIndex);
     }
   }

   canExit() {
    if (this.addControls.dirty && this.operation != "Add") {
      return this.commonService.CanDeactivateBanner();
    }
    else {
      return Promise.resolve(true);
    }
  }
}

